import OrganizationCard from "./OrganizationCard";
import collectionPointsImg from "../images/map.jpg";

function CollectionPoints() {
  const collectionPoints = [
    {
      name: "LES POINTS DE COLLECTE CONNUES DANS L'HEXAGONE",
      objective:
        "Voici les lieux où vous pouvez déposer vos dons. Si vous connaissez un lieu qui n'est pas sur la carte ? Contactez hellobrownboard@gmail.com. Réalisation ABDOU Faina.",
      verificationDate: "18/12/2024",
      // imageUrl: collectionPointsImg,
      link: "https://docs.google.com/spreadsheets/u/2/d/e/2PACX-1vQXCKZS2DvP70sCCBBAcsX9xJpQ7gmRLteO5TIIpxlsnDoVZwpArmrIZIxPiwYfBWh3vxp9UoEzI7j6/pubhtml?pli=1",
      buttonText: "Cliquez ici pour accéder aux informations",
    },
  ];

  return (
    <div className="collection-points-grid">
      {collectionPoints.map((point, index) => (
        <OrganizationCard
          key={index}
          organization={point.name}
          objective={point.objective}
          verificationDate={point.verificationDate}
          imageUrl={point.imageUrl}
          link={point.link}
          buttonText={point.buttonText}
        />
      ))}
    </div>
  );
}

export default CollectionPoints;
